export default class GenericBooleanValue {
  constructor(name, initialValue, namespace) {
    // console.log(name, initialValue, namespace);
    this.namespace = namespace;
    this.name = name;
    this.value = false; // default to false
    if (initialValue) {
      this.parseInputJSON(initialValue);
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getValue() {
    return this.value;
  }

  setValue(value) {
    this.value = !!value;
  }

  getCurrentValue() {
    return this.value;
  }

  setCurrentValue(value) {
    this.value = !!value;
  }

  /* getExpandedFormatValue() {
    return this.getCurrentValue(); // just a boolean
  } */

  getExpandedFormatValue() { // for some reason expanded returns this with @value
    const obj = {
      "@value": this.getCurrentValue(),
    };
    return [obj];
  }


  isEmpty() {
    return typeof this.value !== "boolean";
  }
  parseInputJSON(inputJSON) { // for some reason expanded returns with @value
    let val = null;
    if (inputJSON[this.namespace]) {
      val = inputJSON[this.namespace][0];
    } else {
      val = inputJSON;
    }
    this.setCurrentValue(val["@value"]);
  }

  /* parseInputJSON(inputJSON) {
    this.setCurrentValue(inputJSON[this.namespace]);
  } */
}
